import React from 'react';
import PropTypes from 'prop-types';
import EditorComponentWrapper from '@shared/Resources/shared/components/BuilderComponentWrapper';
import EntitySelectionOptions from '@shared/Resources/shared/components/EntitySelectionOptions';
import { PRACTICE } from '../../types';

export const EditorPractice = ({ submitPayload }) => (
  <EntitySelectionOptions entityType={PRACTICE} onItemSelect={submitPayload} />
);

EditorPractice.propTypes = {
  submitPayload: PropTypes.func,
};

export default EditorComponentWrapper(EditorPractice);
